import React from 'react';
import { Link } from 'react-router-dom';
import brandIcon from '../assets/brand-icon.png';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="logo">
              <img src={brandIcon} alt="Budge" className="logo-icon" />
              <span>Budge</span>
            </Link>
            <p>Your smart personal finance companion. Track, budget, save, and grow.</p>
          </div>
          <div className="footer-links">
            <h4>Legal</h4>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms & Conditions</Link>
            <Link to="/delete-account">Delete Account</Link>
          </div>
          <div className="footer-links">
            <h4>Product</h4>
            <a href="/#features">Features</a>
            <a href="/#how-it-works">How It Works</a>
            <a href="/#security">Security</a>
          </div>
          <div className="footer-links">
            <h4>Contact</h4>
            <a href="mailto:support@budgeapp.com">support@budgeapp.com</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Budge. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
